import { createProject } from '@/domain/model/defaults';
import { randomIds } from '@/domain/model/ids';
import type { NailShapeId, ProjectDocument } from '@/domain/model/types';
import { getProjectRepository, type ProjectRepository } from '@/repositories/projectRepository';
import { storeProjectThumbnail } from './thumbnails';

/** Creates and stores a new single-nail project; returns it once it is saved. */
export async function createAndSaveProject(
  options: { name?: string; shape?: NailShapeId; repository?: ProjectRepository } = {},
): Promise<ProjectDocument> {
  const repository = options.repository ?? getProjectRepository();
  const doc = createProject({
    ids: randomIds,
    now: new Date(),
    ...(options.name ? { name: options.name } : {}),
    ...(options.shape ? { shape: options.shape } : {}),
  });
  await repository.save(doc, null);
  await storeProjectThumbnail(repository, doc);
  return doc;
}

/** Stores an already-built document as a new project (import, set templates, duplicates). */
export async function saveAsNewProject(
  doc: ProjectDocument,
  repository: ProjectRepository = getProjectRepository(),
): Promise<ProjectDocument> {
  await repository.save(doc, null);
  await storeProjectThumbnail(repository, doc);
  return doc;
}
